import type { IMasterDataReasonCodeMappingRepository } from "@src/domain/repositories/masterData";
import type { DeleteAllMasterDataReasonCodeMappingsDTO } from "@src/domain/dto/masterData";

export class DeleteAllMasterDataReasonCodeMappingsUseCase {
  private readonly repository: IMasterDataReasonCodeMappingRepository;

  constructor(repository: IMasterDataReasonCodeMappingRepository) {
    this.repository = repository;
  }

  execute(params: DeleteAllMasterDataReasonCodeMappingsDTO) {
    return this.repository.deleteAllReasonCodeMappings(params);
  }
}
